export default "__VITE_ASSET__DyC_Ltz___"